import { apiClient } from '../../../../api/axios';
import type { ApiResponse, PaginatedResponse } from '../common/types';
import type {
    SubmissionRevisionRequest,
    GetSubmissionRevisionByDeskPayload,
    AssignMembersForRevisedCopyReviewPayload,
    AssignRevisedCopyReviewPanelResult,
    AssignedRevisedCopyReview,
    AssignedRevisedCopyReviewPayload,
    RevisedCopyAssessmentProcessItem,
    GetRevisedCopyAssessmentProcessPayload,
    SubmitFinalDecisionOnRevisedCopyPayload,
    SubmitRevisedCopyMemberReviewPayload,
} from './types';

export const revisedCopyByDeskService = {
    getSubmissionRevisionByDesk: async (
        payload: GetSubmissionRevisionByDeskPayload
    ): Promise<ApiResponse<PaginatedResponse<SubmissionRevisionRequest>>> => {
        const response = await apiClient.post(
            '/RevisedCopy/GetSubmissionRevisionByDesk',
            {
                pageNumber: payload.pageNumber,
                pageSize: payload.pageSize,
                sortBy: payload.sortBy || '',
                sortDescending: payload.sortDescending ?? true,
                search: payload.search || '',
                categoryId: payload.categoryId ?? 0,
            }
        );
        return response.data;
    },

    getAllSubmissionRevision: async (
        payload: GetSubmissionRevisionByDeskPayload
    ): Promise<ApiResponse<PaginatedResponse<SubmissionRevisionRequest>>> => {
        const response = await apiClient.post(
            '/RevisedCopy/GetAllSubmissionRevision',
            {
                pageNumber: payload.pageNumber,
                pageSize: payload.pageSize,
                sortBy: payload.sortBy || '',
                sortDescending: payload.sortDescending ?? true,
                search: payload.search || '',
                categoryId: payload.categoryId && payload.categoryId > 0 ? payload.categoryId : null,
            }
        );
        return response.data;
    },

    getRevisionRequestsBySubmissionId: async (
        submissionId: string
    ): Promise<ApiResponse<SubmissionRevisionRequest[]>> => {
        const response = await apiClient.get(
            `/RevisedCopy/GetRevisionRequestsBySubmissionId?submissionId=${submissionId}`
        );
        return response.data;
    },

    assignMembersForRevisedCopyReview: async (
        payload: AssignMembersForRevisedCopyReviewPayload
    ): Promise<ApiResponse<AssignRevisedCopyReviewPanelResult[]>> => {
        const response = await apiClient.post(
            '/RevisedCopy/GroupMemberAssignmentForRevisedCopyReview',
            payload
        );
        return response.data;
    },

    GetAssignedRevisedCopyAssignmentByMember: async (
        payload: AssignedRevisedCopyReviewPayload
    ): Promise<ApiResponse<PaginatedResponse<AssignedRevisedCopyReview>>> => {
        const response = await apiClient.post(
            '/RevisedCopy/GetAssignedRevisedCopyAssignmentByMember',
            {
                pageNumber: payload.pageNumber,
                pageSize: payload.pageSize,
                sortBy: payload.sortBy || '',
                sortDescending: payload.sortDescending ?? true,
            }
        );
        return response.data;
    },

    getRevisedCopyAssessmentProcess: async (
        payload: GetRevisedCopyAssessmentProcessPayload
    ): Promise<ApiResponse<PaginatedResponse<RevisedCopyAssessmentProcessItem>>> => {
        const response = await apiClient.post(
            '/RevisedCopy/GetRevisedCopyAssessmentProcess',
            {
                pageNumber: payload.pageNumber,
                pageSize: payload.pageSize,
                sortBy: payload.sortBy || '',
                sortDescending: payload.sortDescending ?? true,
                search: payload.search || '',
                completed: payload.completed,
                categoryId: payload.categoryId,
            }
        );
        return response.data;
    },

    deleteRevisedCopyReviewAssignment: async (
        revisedCopyReviewId: string
    ): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post(
            `/RevisedCopy/DeleteRevisedCopyReviewAssignment?revisedCopyReviewId=${revisedCopyReviewId}`
        );
        return response.data;
    },

    submitFinalDecisionOnRevisedCopyReview: async (
        payload: SubmitFinalDecisionOnRevisedCopyPayload
    ): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post(
            '/RevisedCopy/SubmitFinalDecisionOnRevisedCopyReview',
            payload
        );
        return response.data;
    },

    submitRevisedCopyMemberReview: async (
        payload: SubmitRevisedCopyMemberReviewPayload
    ): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post(
            '/RevisedCopy/SubmitRevisedCopyMemberReview',
            payload
        );
        return response.data;
    },
};
